import EmptyPageBanner from './empty-page-banner'

export default EmptyPageBanner
